export enum AccountingWorkflowKey {
  SPLIT_BY_CHECK = "SPLIT_BY_CHECK",
  SPLIT_BY_CHECK_AND_DEDUCTION_TYPE_CATEGORY = "SPLIT_BY_CHECK_AND_DEDUCTION_TYPE_CATEGORY",
}

export interface AccountingWorkflowCategorySplitProps {
  deductionTypeCategoryId: number | null;
  deductionTypeCategoryKey: string | null;
  deductionTypeCategoryName: string | null;
  splitOrder: number | null;
}

export interface AccountingWorkflowProps {
  workflowId: number | null;
  workflowKey: string | null;
  workflowName: string | null;
  workflowDescription: string | null;
  isActive: boolean | null;
  categorySplits: AccountingWorkflowCategorySplitProps[] | null;
}

export interface AccountingProps {
  accountingSystemName: string;
  accountingSystemKey: string;
  accountingSystemDisplayName: string;
  accountingSystemShorthand: string;
  creditMemoDocumentNumberPattern?: string | null;
  workflow?: AccountingWorkflowProps | null;
}

export class Accounting implements AccountingProps {
  private readonly _accountingSystemName: string;
  private readonly _accountingSystemKey: string;
  private readonly _accountingSystemDisplayName: string;
  private readonly _accountingSystemShorthand: string;
  private readonly _creditMemoDocumentNumberPattern: string | null;
  private readonly _workflow: AccountingWorkflowProps | null;

  constructor(props: AccountingProps) {
    this._accountingSystemName = props.accountingSystemName;
    this._accountingSystemKey = props.accountingSystemKey;
    this._accountingSystemDisplayName = props.accountingSystemDisplayName;
    this._accountingSystemShorthand = props.accountingSystemShorthand;
    this._creditMemoDocumentNumberPattern = props.creditMemoDocumentNumberPattern?.trim() || null;
    this._workflow = props.workflow ?? null;
  }

  public get accountingSystemName(): string {
    return this._accountingSystemName;
  }

  public get accountingSystemKey(): string {
    return this._accountingSystemKey;
  }

  public get accountingSystemDisplayName(): string {
    return this._accountingSystemDisplayName;
  }

  public get accountingSystemShorthand(): string {
    return this._accountingSystemShorthand;
  }

  public get creditMemoDocumentNumberPattern(): string | null {
    return this._creditMemoDocumentNumberPattern;
  }

  public get workflow(): AccountingWorkflowProps | null {
    return this._workflow;
  }

  public get workflowKey(): string | null {
    return this._workflow?.workflowKey ?? null;
  }
}
